// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { editCardModalStyles } from "@conklin/Overrides/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

editCardModalStyles.bottomGridItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

editCardModalStyles.notifyError = {
    css: css`
        margin-bottom: 0;
        align-self: flex-start;
        max-width: 100%;
        ${xScreen("lte", "sm")} {
            margin-bottom: 30px;
        }
    `,
};

editCardModalStyles.notifyErrorWrapper = {
    css: css`
        padding: 10px;
    `,
};

editCardModalStyles.notifyErrorWrapperLarge = {
    css: css`
        width: 100%;
    `,
};

editCardModalStyles.container = {
    gap: 0,
};

editCardModalStyles.leftColumn = editCardModalStyles.rightColumn = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
        padding: 15px;
    `,
};

editCardModalStyles.bottomGridItem = {
    width: 12,
    css: css`
        padding: 15px;
    `,
};
